import {TipoAreaAmostral} from "./enums";
import {Bioma} from "./Bioma";
import {
  Column,
  Entity,
  JoinTable,
  ManyToMany,
  ManyToOne,
  PrimaryGeneratedColumn,
} from "typeorm";
import {JoinColumn, OneToMany} from "typeorm/browser";
import {Entidade} from "./Entidade";

@Entity("local")
// @Tree("materialized-path")
export class Local  extends Entidade {
    @Column({nullable: false})
    nome?: string
    @Column({nullable: true})
    tipo?: TipoAreaAmostral
    @ManyToMany(() => Bioma, {cascade: true})
    @JoinTable({
      name: 'local_bioma',
      joinColumn: {
        name: 'local_id',
        referencedColumnName: 'id',
      },
      inverseJoinColumn: {
        name: 'biomas_id',
        referencedColumnName: 'id',
      },
    })
    biomas?: Bioma[]
    // @TreeParent()
    @JoinColumn({name: "pai_id"})
    @ManyToOne(() => Local, (local) => local.locais)
    pai?: Local
    @Column()
    agencia_sigla?: string
    // @TreeChildren()
    @OneToMany(() => Local, (local) => local.pai)
    locais?: Local[]
}
